type NotificationData = Record<string, string> | null | undefined;

/** Prefer an explicit in-app destination; older notifications fall back to
 * their public festival page.
 */
export function notificationDestination(data: NotificationData): string | null {
  const deepLink = data?.deep_link?.trim();
  if (deepLink?.startsWith("/")) return deepLink;

  const festivalSlug = data?.festival_slug?.trim();
  return festivalSlug ? `/live/${festivalSlug}` : null;
}
